'use client';

import { BlogAboutPage } from '@/components/pages/blog/BlogAboutPage';
import { useAppNavigate } from '../_lib/useAppNavigate';

export default function BlogAboutClient() {
  const navigate = useAppNavigate();
  return <BlogAboutPage onNavigate={navigate} />;
}
